import { render, staticRenderFns } from "./Qualification.vue?vue&type=template&id=52856690&scoped=true&"
import script from "./Qualification.vue?vue&type=script&lang=js&"
export * from "./Qualification.vue?vue&type=script&lang=js&"
import style0 from "./Qualification.vue?vue&type=style&index=0&id=52856690&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52856690",
  null
  
)

export default component.exports